import Message from 'carbon-react/lib/components/message';

const CarbonToast = ({ closeToast, variant, message }) => {
  return (
    <Message className="carbon-toast" onDismiss={closeToast} open variant={variant}>
      {message}
    </Message>
  );
};

export default CarbonToast;
